import { getLink } from './getLink';
import type { ValidHref } from './types';

export function getLinkToProjectWithMemberDialogOpen({
  projectId,
}: {
  projectId: string;
}): ValidHref {
  const projectLink = getLink({
    page: 'project',
    projectId,
  });
  const urlSearchParams = new URLSearchParams();

  urlSearchParams.set('members_dialog_open', 'true');

  return `${projectLink}?${urlSearchParams.toString()}`;
}
